<template>
  <div>
    <footer v-if="$vuetify.theme.dark == true" class="footerB">
      <v-container class="lighten-5">
        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ifsc-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <h5>INSTITUTO FEDERAL</h5>
            <p style="font-size: 10px;">SANTA CATARINA</p>
          </v-col>

          <v-spacer />

          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/epagri-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="visibility:hidden; font-size: 11px; line-height:0;">
              Spacer
            </p>
            <p style="font-size: 11px; line-height:0;">
              Empresa de Pesquisa Agropecuária
            </p>
            <p style="font-size: 11px; line-height:0;">
              E Extensão Rural de Santa Catarina
            </p>
          </v-col>
          <v-spacer />
          <v-col
            style="padding-right:0px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ABPM.png"
              transition="scale-transition"
              width="60"
            />
          </v-col>
          <v-col
            style="padding-top:20px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <p style="font-size: 11px; line-height:0;">
              Associação Brasileira
            </p>
            <p style="font-size: 11px; line-height:0;">
              de Produtores de Maçã
            </p>
          </v-col>
          <v-spacer />
        </v-row>

        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Heitor Vila Lobos, 222
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro São Francisco - Lages, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">CEP 88506-400</p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3221-4200</p>
          </v-col>
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">SEDE DA EPAGRI</p>
            <p style="font-size: 11px; line-height:0;">
              Rodovia Admar Gonzaga, 1347 - Itacorubi
            </p>
            <p style="font-size: 11px; line-height:0;">
              Florianópolis, SC - Brasil - CEP 88034-901
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (48) 3665-5000</p>
          </v-col>
          <v-spacer />
          <p style="visibility:hidden">spacer</p>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Nereu Ramos, 1061
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro Centro - Fraiburgo, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">
              CEP 89580-000
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3246-2686</p>
          </v-col>

          <v-spacer />
        </v-row>
      </v-container>
    </footer>
    <footer v-else class="footerL">
      <v-container class="lighten-5">
        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ifsc-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <h5>INSTITUTO FEDERAL</h5>
            <p style="font-size: 10px;">SANTA CATARINA</p>
          </v-col>

          <v-spacer />

          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/epagri-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="visibility:hidden; font-size: 11px; line-height:0;">
              Spacer
            </p>
            <p style="font-size: 11px; line-height:0;">
              Empresa de Pesquisa Agropecuária
            </p>
            <p style="font-size: 11px; line-height:0;">
              E Extensão Rural de Santa Catarina
            </p>
          </v-col>
          <v-spacer />
          <v-col
            style="padding-right:0px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ABPM.png"
              transition="scale-transition"
              width="60"
            />
          </v-col>
          <v-col
            style="padding-top:20px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <p style="font-size: 11px; line-height:0;">
              Associação Brasileira
            </p>
            <p style="font-size: 11px; line-height:0;">
              de Produtores de Maçã
            </p>
          </v-col>
          <v-spacer />
        </v-row>

        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Heitor Vila Lobos, 222
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro São Francisco - Lages, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">CEP 88506-400</p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3221-4200</p>
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
            style="margin-left:-10px"
          >
            <p style="font-size: 11px; line-height:0;">SEDE DA EPAGRI</p>
            <p style="font-size: 11px; line-height:0;">
              Rodovia Admar Gonzaga, 1347 - Itacorubi
            </p>
            <p style="font-size: 11px; line-height:0;">
              Florianópolis, SC - Brasil - CEP 88034-901
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (48) 3665-5000</p>
          </v-col>
          <v-spacer />
          <p style="visibility:hidden">spacer</p>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Nereu Ramos, 1061
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro Centro - Fraiburgo, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">
              CEP 89580-000
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3246-2686</p>
          </v-col>

          <v-spacer />
        </v-row>
      </v-container>
    </footer>

    <footer v-if="$vuetify.theme.dark == true" class="footerA">
      <v-container class="lighten-5">
        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ifsc-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <h5>INSTITUTO FEDERAL</h5>
            <p style="font-size: 10px;">SANTA CATARINA</p>

            <p style="font-size: 11px; line-height:0;">
              Rua Heitor Vila Lobos, 222
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro São Francisco - Lages, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">CEP 88506-400</p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3221-4200</p>
          </v-col>
          <v-spacer />

          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/epagri-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Empresa de Pesquisa Agropecuária
            </p>
            <p style="font-size: 11px; line-height:0;">
              E Extensão Rural de Santa Catarina
            </p>
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">SEDE DA EPAGRI</p>
            <p style="font-size: 11px; line-height:0;">
              Rodovia Admar Gonzaga, 1347 - Itacorubi
            </p>
            <p style="font-size: 11px; line-height:0;">
              Florianópolis, SC - Brasil - CEP 88034-901
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (48) 3665-5000</p>
          </v-col>
          <v-spacer />

          <v-col
            style="padding-right:0px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ABPM.png"
              transition="scale-transition"
              width="60"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Associação Brasileira
            </p>
            <p style="font-size: 11px; line-height:0;">
              de Produtores de Maçã
            </p>
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Nereu Ramos, 1061
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro Centro - Fraiburgo, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">
              CEP 89580-000
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3246-2686</p>
          </v-col>
        </v-row>
      </v-container>
    </footer>
    <footer v-else class="footerC">
      <v-container class="lighten-5">
        <v-row justify="center">
          <v-spacer />
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ifsc-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <h5>INSTITUTO FEDERAL</h5>
            <p style="font-size: 10px;">SANTA CATARINA</p>
            <p style="font-size: 11px; line-height:0;">
              Rua Heitor Vila Lobos, 222
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro São Francisco - Lages, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">CEP 88506-400</p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3221-4200</p>
          </v-col>
          <v-spacer />

          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/epagri-logo.png"
              transition="scale-transition"
              width="50"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Empresa de Pesquisa Agropecuária
            </p>
            <p style="font-size: 11px; line-height:0;">
              E Extensão Rural de Santa Catarina
            </p>
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">SEDE DA EPAGRI</p>
            <p style="font-size: 11px; line-height:0;">
              Rodovia Admar Gonzaga, 1347 - Itacorubi
            </p>
            <p style="font-size: 11px; line-height:0;">
              Florianópolis, SC - Brasil - CEP 88034-901
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (48) 3665-5000</p>
          </v-col>
          <v-spacer />

          <v-col
            style="padding-right:0px"
            cols="12"
            xs="auto"
            sm="auto"
            md="auto"
            lg="auto"
          >
            <v-img
              alt="Ifsc"
              class="center"
              contain
              src="../../../../styles/assets/ABPM.png"
              transition="scale-transition"
              width="60"
            />
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Associação Brasileira
            </p>
            <p style="font-size: 11px; line-height:0;">
              de Produtores de Maçã
            </p>
          </v-col>
          <v-col cols="12" xs="auto" sm="auto" md="auto" lg="auto">
            <p style="font-size: 11px; line-height:0;">
              Rua Nereu Ramos, 1061
            </p>
            <p style="font-size: 11px; line-height:0;">
              Bairro Centro - Fraiburgo, SC - Brasil
            </p>
            <p style="font-size: 11px; line-height:0;">
              CEP 89580-000
            </p>
            <p style="font-size: 11px; line-height:0;">Fone: (49) 3246-2686</p>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </div>
</template>

<script>
export default {
  name: "defaultFooter"
};
</script>

<style scoped>
.footerL,
.footerC {
  padding: 15px 0;
  background-color: #f2f2f2;
  color: #000;
}
.footerB,
.footerA {
  padding: 15px 0;
  background-color: rgb(39, 39, 39);
  color: #fff;
}
@media only screen and (max-width: 707px) {
  .footerL {
    display: none;
  }
  .footerB {
    display: none;
  }
}
@media only screen and (min-width: 708px) {
  .footerA {
    display: none;
  }
  .footerC {
    display: none;
  }
}
</style>
